// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-section {
    font-size: .9rem;
    line-height: 1.6;
    padding: 0 20px;
  }
  
  @media (max-width: 768px) {
    .profile-section {
      font-size: .7rem;
    }
  }
  
  `, "",{"version":3,"sources":["webpack://./src/styles/ProfileSection.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE;MACE,gBAAgB;IAClB;EACF","sourcesContent":[".profile-section {\r\n    font-size: .9rem;\r\n    line-height: 1.6;\r\n    padding: 0 20px;\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .profile-section {\r\n      font-size: .7rem;\r\n    }\r\n  }\r\n  \r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
